import React from 'react';
import { observer } from 'mobx-react';

import AppStorage from '../Storage/Storage';
import { translate } from '../utils/utils';
import Labels from '../enums/Labels';

class ErrorScreenContacts extends React.PureComponent {
  private readonly storage: AppStorage;

  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(props: {}) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  render(): React.ReactElement {

    const productSpecificData = this.storage.getProductSpecificInfo;

    return (
      <>
        <h5>
          {translate(Labels.ERROR_CONTACTS_HEADER, this.storage.getLocale)}
        </h5>
        <p className="errorScreenContacts">
          <span className="errorScreenContacts-titles">
            T:
          </span>
            &nbsp;
          <span>
            <a href={`tel:${productSpecificData.telephoneNumberHref}`}>{productSpecificData.telephoneNumber}</a>
          </span>
          <br />
          <span className="errorScreenContacts-titles">
            E:
          </span>
            &nbsp;
          <span>
            {productSpecificData.infoEmail}
          </span>
        </p>
      </>
    );
  }
}

export default observer(ErrorScreenContacts);
